import { render, staticRenderFns } from "./identify.vue?vue&type=template&id=b2216d88&scoped=true"
import script from "./identify.vue?vue&type=script&lang=js"
export * from "./identify.vue?vue&type=script&lang=js"
import style0 from "./identify.vue?vue&type=style&index=0&id=b2216d88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2216d88",
  null
  
)

export default component.exports